import React from 'react';
import { Image } from 'react-native';
import type { AccountProps, CodeRequestProps, MyPlayerProps, PlayerReferralProps, PromoProps, PublicPlayerProps, RewardOptionProps } from '../../types';
import { Icons } from '../../Components';
import { useColors } from '../../constants/useColors';
import { Button, Text, View } from '../../Components/Themed';

type FundAccountCardProps = {
    player:MyPlayerProps,
    accounts:AccountProps[],
    code_details: {
        code_request?:CodeRequestProps,
        referrer?:PublicPlayerProps,
        promo?:PromoProps,
        player_referral?:PlayerReferralProps,
        reward_option?:RewardOptionProps
    }
    walkthrough?:boolean,
    onManualACH: () => void,
    onCard:(account?:AccountProps) => void,
    onSelectAccount: (account:AccountProps) => void,
    onClose: () => void,
    onNext: () => void,
}

const FundAccountCard = ({ accounts, code_details, onClose, onCard, onNext, walkthrough, onManualACH, onSelectAccount }:FundAccountCardProps) => {
    const Colors = useColors();
    const { code_request, promo, referrer } = code_details;

    const manual_account = accounts.find(a => a.ach_detail && a.ach_detail.ach_type == 'manual');
    const ibt_placeholder_account = accounts.find(a => a.ibt_placeholder);
    const ibt_account = accounts.find(a => a.ach_detail && a.ach_detail.ach_type == 'ibf' && !a.ibt_placeholder);
    const card_account = accounts.find(a => a.account_type == 'card');
    const paypal_account = accounts.find(a => a.account_type == 'paypal');

    return (
        <View style={{ flex:1 }}>
            <View style={{ padding:20 }}>
                <Text size={26} theme='h1'>FUND YOUR BETTOREDGE WALLET</Text>
                <Text style={{ marginTop:10 }} size={16} theme='description'>In order to fund your real-money/USD ($) balance, simply make a deposit using the following options</Text>
            </View>
            <View style={{ flex:1, padding:20 }}>
                <View nativeID='fund_account_now'>
                <Text size={18} theme='h1'>FUND YOUR ACCOUNT NOW</Text>
                {ibt_placeholder_account ?
                <View style={{ marginTop:15 }}>
                    <Button float style={{padding:3, flexDirection:'row', alignItems:'center', borderRadius:30 }}
                        onPress={() => onSelectAccount(ibt_placeholder_account)}>
                        <View float style={{  height:50, width:50, borderRadius:100, backgroundColor:Colors.text.white, justifyContent:'center', alignItems:'center' }}>
                            <Icons.PlaidIcon size={22} color={Colors.text.h1} />
                        </View>
                        <View transparent style={{ flex:1, marginLeft:10, marginRight:10 }}>
                            <Text size={14} theme='h1'>INSTANT BANK TRANSFER</Text>
                            <Text style={{ marginTop:3 }} size={12} theme='description'>When you link an account you get access to both instant deposits and instant withdraws.</Text>
                        </View>
                    </Button>
                    {ibt_account ?
                    <View transparent style={{ position:'absolute', top:5, right:5, bottom:0}}>
                        <Icons.TransactionSuccessIcon size={45}/>
                    </View>
                    :<></>}
                </View>
                :<></>}
                <View style={{ marginTop:10 }}>
                    <Button float style={{ padding:3, flexDirection:'row', alignItems:'center', borderRadius:30, backgroundColor:Colors.absolutes.brand.cyan }}
                        onPress={() => onCard(card_account)}>
                        <View float style={{  height:50, width:50, borderRadius:100, justifyContent:'center', alignItems:'center', backgroundColor:Colors.text.white }}>
                            <Icons.CreditCardIcon size={22} color={Colors.absolutes.brand.cyan} />
                        </View>
                        <View transparent style={{ flex:1, marginLeft:10 }}>
                            <Text size={14} color={Colors.text.white} weight='bold'>DEBIT / CREDIT CARD</Text>
                            <Text style={{ marginTop:3 }} size={12} color={Colors.text.white} weight='semibold'>Add a debit / credit card and deposit instantly.</Text>
                        </View>
                    </Button>
                    {card_account ?
                    <View transparent style={{ position:'absolute', top:5, right:5, bottom:0}}>
                        <Icons.TransactionSuccessIcon size={45}/>
                    </View>
                    :<></>}
                </View>
                {paypal_account ?
                <View style={{ marginTop:10 }}>
                    <Button float style={{ padding:3, flexDirection:'row', alignItems:'center', borderRadius:30, backgroundColor:Colors.absolutes.company.paypal }}
                        onPress={() => onSelectAccount(paypal_account)}>
                        <View style={{  height:50, width:50, borderRadius:100, justifyContent:'center', alignItems:'center', backgroundColor:Colors.text.white }}>
                            <Icons.PayPalIcon size={22}/>
                        </View>
                        <View transparent style={{ flex:1, marginLeft:10 }}>
                            <Text size={14} color={Colors.absolutes.company.paypal_blue} weight='bold'>PAYPAL</Text>
                            <Text style={{ marginTop:3 }} size={12} color={Colors.absolutes.company.paypal_blue} weight='semibold'>Use your paypal account to deposit instantly.</Text>
                        </View>
                    </Button>
                </View>
                :<></>}
                </View>
                <View style={{ marginTop:20 }}>
                    <Text size={18} theme='h1'>FUND LATER (~1-3 BUSINESS DAYS)</Text>
                    <View style={{ marginTop:15 }}>

                        <Button float style={{ padding:3, flexDirection:'row', alignItems:'center', borderRadius:30 }}
                        onPress={() => onManualACH()}>
                            <View float style={{  height:50, width:50, borderRadius:100, justifyContent:'center', alignItems:'center'}}>
                                <Icons.BankIcon size={22} color={Colors.text.h1} />
                            </View>
                            <View transparent style={{ flex:1 }}>
                                <Text size={14} theme='h1' textAlign='center'>ADD MANUAL ACH ACCOUNT</Text>
                            </View>
                        </Button>
                        {manual_account?
                        <View transparent style={{ position:'absolute', top:5, right:5, bottom:0}}>
                            <Icons.TransactionSuccessIcon size={45}/>
                        </View>
                        :<></>}
                    </View>
                </View>
            </View>
            {code_request?.pending_deposit && promo && referrer && ['referral_code','referral_sweepstakes'].includes(promo.type) ?
            <View float style={{ margin:15, flexDirection:'row' }}>
                <View transparent style={{ justifyContent:'center' }}>
                    {referrer?.profile_pic?
                    <Image
                        source={{ uri: referrer.profile_pic }}
                        style={{ height: 60, width:60, borderRadius:4 }}
                        resizeMode='cover'
                    />
                    :
                    <Icons.GiftIcon size={40} color={Colors.text.gold} />
                    }
                </View>
                <View transparent style={{flex:1, backgroundColor:Colors.absolutes.incentive.gold_faded, padding:10 }}>
                    <Text style={{ paddingBottom:10, borderBottomWidth:1, borderBottomColor:Colors.borders.light }} size={14} theme='h1'>Give back to {referrer?.username}</Text>
                    <Text style={{ paddingTop:5 }} size={12} color={Colors.text.h1} weight='semibold'>Make a qualifying deposit and {referrer.username} will receive a reward!</Text>
                </View>
            </View>
            :<></>}
            {walkthrough ?
            <View nativeID='action_row' style={{ flexDirection:'row', justifyContent:'space-between', padding:10 }}>
                <Button
                    title={!ibt_account && !manual_account ? 'DO THIS LATER' : 'All Set!'}
                    title_color={!ibt_account && !manual_account ? Colors.text.error: Colors.text.success}
                    backgroundColor='transparent'
                    onPress={() => onClose()}
                />
                <Button
                    float
                    style={{ borderRadius:100, height:50, width:50, justifyContent:'center', alignItems:'center' }}
                    disabled={!manual_account && !ibt_account ? true : false}
                    onPress={() => onNext()}
                >
                    <Icons.ChevronIcon size={18} direction='right' color={Colors.text.h1}/>
                </Button>
            </View>
            :<></>}
        </View>
    )
}

export default FundAccountCard